export const LANGS = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "ti", label: "ትግርኛ", flag: "🇪🇷" },
];

export const translations = {
  en: {
    nav: { home: "Home", programs: "Programs", summer: "Summer Camp", gallery: "Gallery", about: "About", educators: "Educators", contact: "Contact", portal: "Parent Portal", bookTour: "Book a Tour" },
    hero: {
      title: "Where little ones grow through art, nature, and nourishment",
      subtitle: "A warm, Reggio-Emilia inspired family childcare in Seattle. Caring for children 6 weeks to 5 years.",
      cta1: "Book a Tour", cta2: "Explore Programs",
    },
    info: { hours: "Hours", ages: "Ages", availability: "Availability", enrollCta: "Join the Waitlist" },
    sections: {
      signatureTitle: "Our Signature Programs",
      signatureSub: "Three special studios woven into every child's day.",
      programsTitle: "Programs by Age",
      philosophyTitle: "Our Teaching Philosophy",
      scheduleTitle: "A Day at Ainalem",
      mealsTitle: "Nourishing Meals",
      teachersTitle: "Meet the Teachers",
      testimonialsTitle: "Loved by Families",
      faqTitle: "Frequently Asked Questions",
      galleryTitle: "Inside Our World",
      ctaTitle: "Ready to visit us?",
      ctaSub: "Book a tour and see the warmth of Ainalem for yourself.",
      deibTitle: "Diversity, Equity, Inclusion & Belonging",
      deibSub: "Every family belongs here. We offer support in English, Spanish, Italian, and Tigrigna.",
    },
    form: {
      contact: "Contact Us", tour: "Request a Tour", enroll: "Enrollment Inquiry", camp: "Summer Camp Inquiry",
      name: "Your Name", email: "Email", phone: "Phone", childName: "Child's Name", childAge: "Child's Age",
      program: "Program of Interest", date: "Preferred Date", message: "Message", submit: "Send", sending: "Sending...",
      success: "Thank you! We'll be in touch within one business day.",
    },
    chat: { title: "Ask Amina", placeholder: "Ask about hours, programs, tours...", greeting: "Hi! I'm Amina 🌟 How can I help your family today?" },
    portal: { welcome: "Welcome", announcements: "Announcements", payments: "Payments & Tuition", resources: "Resources & Forms", logout: "Log Out", pay: "Pay Now" },
    auth: { login: "Log In", register: "Create Account", email: "Email", password: "Password", name: "Full Name", child: "Child's Name (optional)", haveAccount: "Already have an account?", noAccount: "New family?", loginBtn: "Log In", registerBtn: "Create Account" },
  },
  es: {
    nav: { home: "Inicio", programs: "Programas", summer: "Campamento de Verano", gallery: "Galería", about: "Nosotros", educators: "Educadores", contact: "Contacto", portal: "Portal de Padres", bookTour: "Reservar Visita" },
    hero: {
      title: "Donde los pequeños crecen a través del arte, la naturaleza y la nutrición",
      subtitle: "Un cálido cuidado infantil familiar inspirado en Reggio-Emilia en Seattle. Para niños de 6 semanas a 5 años.",
      cta1: "Reservar Visita", cta2: "Ver Programas",
    },
    info: { hours: "Horario", ages: "Edades", availability: "Disponibilidad", enrollCta: "Unirse a la Lista" },
    sections: {
      signatureTitle: "Nuestros Programas Especiales", signatureSub: "Tres estudios especiales en el día de cada niño.",
      programsTitle: "Programas por Edad", philosophyTitle: "Nuestra Filosofía", scheduleTitle: "Un Día en Ainalem",
      mealsTitle: "Comidas Nutritivas", teachersTitle: "Conoce a los Maestros", testimonialsTitle: "Amado por las Familias",
      faqTitle: "Preguntas Frecuentes", galleryTitle: "Nuestro Mundo", ctaTitle: "¿Listo para visitarnos?",
      ctaSub: "Reserve una visita y descubra la calidez de Ainalem.", deibTitle: "Diversidad, Equidad e Inclusión",
      deibSub: "Cada familia pertenece aquí. Ofrecemos apoyo en inglés, español, italiano y tigriña.",
    },
    form: {
      contact: "Contáctenos", tour: "Solicitar Visita", enroll: "Consulta de Inscripción", camp: "Consulta Campamento",
      name: "Su Nombre", email: "Correo", phone: "Teléfono", childName: "Nombre del Niño", childAge: "Edad del Niño",
      program: "Programa de Interés", date: "Fecha Preferida", message: "Mensaje", submit: "Enviar", sending: "Enviando...",
      success: "¡Gracias! Nos comunicaremos en un día hábil.",
    },
    chat: { title: "Pregunta a Amina", placeholder: "Pregunte sobre horarios, programas...", greeting: "¡Hola! Soy Amina 🌟 ¿Cómo puedo ayudar a su familia?" },
    portal: { welcome: "Bienvenido", announcements: "Anuncios", payments: "Pagos y Matrícula", resources: "Recursos y Formularios", logout: "Salir", pay: "Pagar" },
    auth: { login: "Iniciar Sesión", register: "Crear Cuenta", email: "Correo", password: "Contraseña", name: "Nombre Completo", child: "Nombre del Niño (opcional)", haveAccount: "¿Ya tiene cuenta?", noAccount: "¿Familia nueva?", loginBtn: "Iniciar Sesión", registerBtn: "Crear Cuenta" },
  },
  it: {
    nav: { home: "Home", programs: "Programmi", summer: "Campo Estivo", gallery: "Galleria", about: "Chi Siamo", educators: "Educatori", contact: "Contatti", portal: "Portale Genitori", bookTour: "Prenota Visita" },
    hero: {
      title: "Dove i piccoli crescono attraverso arte, natura e nutrimento",
      subtitle: "Un accogliente asilo familiare ispirato a Reggio-Emilia a Seattle. Per bambini da 6 settimane a 5 anni.",
      cta1: "Prenota Visita", cta2: "Scopri i Programmi",
    },
    info: { hours: "Orari", ages: "Età", availability: "Disponibilità", enrollCta: "Lista d'Attesa" },
    sections: {
      signatureTitle: "I Nostri Programmi Speciali", signatureSub: "Tre studi speciali nella giornata di ogni bambino.",
      programsTitle: "Programmi per Età", philosophyTitle: "La Nostra Filosofia", scheduleTitle: "Una Giornata ad Ainalem",
      mealsTitle: "Pasti Nutrienti", teachersTitle: "Conosci gli Insegnanti", testimonialsTitle: "Amato dalle Famiglie",
      faqTitle: "Domande Frequenti", galleryTitle: "Il Nostro Mondo", ctaTitle: "Pronti a visitarci?",
      ctaSub: "Prenota una visita e scopri il calore di Ainalem.", deibTitle: "Diversità, Equità e Inclusione",
      deibSub: "Ogni famiglia appartiene qui. Offriamo supporto in inglese, spagnolo, italiano e tigrino.",
    },
    form: {
      contact: "Contattaci", tour: "Richiedi Visita", enroll: "Richiesta Iscrizione", camp: "Richiesta Campo Estivo",
      name: "Il Tuo Nome", email: "Email", phone: "Telefono", childName: "Nome del Bambino", childAge: "Età del Bambino",
      program: "Programma di Interesse", date: "Data Preferita", message: "Messaggio", submit: "Invia", sending: "Invio...",
      success: "Grazie! Ti contatteremo entro un giorno lavorativo.",
    },
    chat: { title: "Chiedi ad Amina", placeholder: "Chiedi di orari, programmi, visite...", greeting: "Ciao! Sono Amina 🌟 Come posso aiutare la tua famiglia?" },
    portal: { welcome: "Benvenuto", announcements: "Annunci", payments: "Pagamenti e Rette", resources: "Risorse e Moduli", logout: "Esci", pay: "Paga" },
    auth: { login: "Accedi", register: "Crea Account", email: "Email", password: "Password", name: "Nome Completo", child: "Nome del Bambino (opzionale)", haveAccount: "Hai già un account?", noAccount: "Nuova famiglia?", loginBtn: "Accedi", registerBtn: "Crea Account" },
  },
  ti: {
    nav: { home: "መደብ", programs: "ፕሮግራማት", summer: "ናይ ሓጋይ ካምፕ", gallery: "ስእልታት", about: "ብዛዕባና", educators: "መምህራን", contact: "ርክብ", portal: "ናይ ወለዲ ፖርታል", bookTour: "ጉብኝት ሓዝ" },
    hero: {
      title: "ንኣሽቱ ብስነ-ጥበብ፣ ተፈጥሮን መግብን ዝዓብዩሉ",
      subtitle: "ኣብ ሲያትል ዝርከብ ብReggio-Emilia ዝተነደፈ ሙቅ ናይ ስድራ ክንክን ህጻናት። ካብ 6 ሰሙን ክሳብ 5 ዓመት።",
      cta1: "ጉብኝት ሓዝ", cta2: "ፕሮግራማት ርአ",
    },
    info: { hours: "ሰዓታት", ages: "ዕድመ", availability: "ተኽእሎ", enrollCta: "ናብ ዝርዝር እቶ" },
    sections: {
      signatureTitle: "ፍሉያት ፕሮግራማትና", signatureSub: "ኣብ ናይ ነፍሲ ወከፍ ህጻን መዓልቲ ዝኣተዉ ሰለስተ ፍሉያት ስቱድዮታት።",
      programsTitle: "ብዕድመ ዝተኸፍለ ፕሮግራማት", philosophyTitle: "ናይ ትምህርቲ ፍልስፍናና", scheduleTitle: "ሓንቲ መዓልቲ ኣብ ኣይናለም",
      mealsTitle: "መኣዛዊ መግቢ", teachersTitle: "መምህራን ተላለ", testimonialsTitle: "ብስድራቤታት ዝፍቶ",
      faqTitle: "ብተደጋጋሚ ዝሕተቱ ሕቶታት", galleryTitle: "ውሽጢ ዓለምና", ctaTitle: "ክትበጽሑና ድሉዋት ዲኹም?",
      ctaSub: "ጉብኝት ሓዝ እሞ ሙቐት ኣይናለም ባዕልኻ ርአ።", deibTitle: "ብዙሕነት፣ ፍትሓዊነትን ሓቛፍነትን",
      deibSub: "ነፍሲ ወከፍ ስድራ ኣብዚ ኣላ። ብእንግሊዝኛ፣ ስፓኛ፣ ጣልያንን ትግርኛን ደገፍ ንህብ።",
    },
    form: {
      contact: "ርኸቡና", tour: "ጉብኝት ሕተት", enroll: "ናይ ምዝገባ ሕቶ", camp: "ናይ ሓጋይ ካምፕ ሕቶ",
      name: "ስምካ", email: "ኢመይል", phone: "ስልኪ", childName: "ስም ህጻን", childAge: "ዕድመ ህጻን",
      program: "ዝድለ ፕሮግራም", date: "ዝምረጽ ዕለት", message: "መልእኽቲ", submit: "ስደድ", sending: "ይለኣኽ ኣሎ...",
      success: "የቐንየልና! ኣብ ውሽጢ ሓደ ናይ ስራሕ መዓልቲ ክንረኽበኩም ኢና።",
    },
    chat: { title: "ንኣሚና ሕተት", placeholder: "ብዛዕባ ሰዓታት፣ ፕሮግራማት ሕተት...", greeting: "ሰላም! ኣሚና እየ 🌟 ሎሚ ንስድራኻ ብኸመይ ክሕግዝ እኽእል?" },
    portal: { welcome: "እንቋዕ ብደሓን መጻእካ", announcements: "ማዕዳታት", payments: "ክፍሊትን ክፍሊ ትምህርትን", resources: "ጸጋታትን ቅጥዕታትን", logout: "ውጻእ", pay: "ክፈል" },
    auth: { login: "እቶ", register: "ሕሳብ ፍጠር", email: "ኢመይል", password: "መሕለፊ ቃል", name: "ምሉእ ስም", child: "ስም ህጻን (ኣማራጺ)", haveAccount: "ሕሳብ ኣለካ ድዩ?", noAccount: "ሓዳስ ስድራ?", loginBtn: "እቶ", registerBtn: "ሕሳብ ፍጠር" },
  },
};
